import { FC, useMemo, useState } from 'react';
import { Card, RadixTable, TColumn } from '@features/ui';
import Pagination from '@features/ui/components/pagination.tsx';
import { TInstrumentsTable } from '@src/types/instruments.ts';
import { instrumentData } from '@features/admin/instruments/instrumentData.ts';

export const InstrumentsTable: FC = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const columns = useMemo(
    (): TColumn<TInstrumentsTable>[] => [
      { title: 'Category', render: (item) => <p>{item?.category}</p> },
      { title: 'Exchange', render: (item) => <p>{item?.exchange}</p> },
      { title: 'Name', render: (item) => <p>{item?.name}</p> },
      { title: 'Symol', render: (item) => <p>{item?.symol}</p> },
      { title: 'TickSize', render: (item) => <p>{item?.tickSize}</p> },
      { title: 'Point Value $', render: (item) => <p>{item?.pointValue}</p> },
    ],
    []
  );

  return (
    <Card className={'py-4'}>
      <p className={'text-[23px]'}>Current Instruments</p>
      <div className={'flex flex-col items-end mt-3'}>
        <RadixTable columns={columns} data={instrumentData} />
        <Pagination
          current={currentPage}
          total={24}
          onChange={setCurrentPage}
        />
      </div>
    </Card>
  );
};
